import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {DocketPrintingRuleData} from "./docket-printing-rule.data";
import {
    MetaTagDefinitionData,
    MetaTagDefinitionReferenceData,
    MetaTagType
} from "../../catalogue/meta-tag/meta-tag.data";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class DocketPrintingRuleEntityModel extends EntityModel<DocketPrintingRuleData> {

    translateService: TranslateService;

    constructor(injector: Injector) {
        super(injector, DocketPrintingRuleData);
        this.translateService = injector.get(TranslateService, null);
    }

    private async addUntaggedTag(processor: DocketPrintingRuleData): Promise<void> {
        if (processor.matchNoTags) {
            const tag: MetaTagDefinitionReferenceData = EntityData.create(MetaTagDefinitionReferenceData);
            tag.metaTagDefinitionId = MetaTagDefinitionData.MATCH_UNTAGGED_ITEM;
            tag.name = await this.translateService.get("wbo.meta-tag.option.modifier.matchNoTags").toPromise();
            tag.type = MetaTagType.DOCKET_SELECTOR;
            processor.tags.unshift(tag);
            processor.matchNoTags = false;
        }
    }

    private removeUntaggedTag(processor: DocketPrintingRuleData): void {
        processor.matchNoTags = !!processor.tags.find((tag: MetaTagDefinitionReferenceData) => tag.metaTagDefinitionId === MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
        processor.tags = processor.tags.filter((tag: MetaTagDefinitionReferenceData) => tag.metaTagDefinitionId !== MetaTagDefinitionData.MATCH_UNTAGGED_ITEM);
    }

    protected override onBeforeSaveEntity(entityData: DocketPrintingRuleData) {
        this.removeUntaggedTag(this.data);
    }

    protected override onAfterLoadEntity(): void {
        this.addUntaggedTag(this.data);
        this.data.selectedExtrasOnly = this.data.extrasTags.length > 0;
    }
}
